<template>
  <div
    id="app"
    :class="{
      dj: agent === 'dj',
      kudu: agent === 'kudu',
      fullscreen: fullscreen,
    }"
  >
    <div class="darkBg"></div>
    <div v-if="step == 'index'" class="contentBox indexStepBox">
      <h1 class="title">本田专用车机优化系统</h1>
      <h2 class="subTitle">思域、冠道、皓影、CRV、URV、CDX专用</h2>
      <div @click="onStart" class="btn">开始优化</div>
    </div>
    <div v-if="step == 'wait'" class="waitBox">
      <div class="waitContentBox">
        <div class="left">
          <div class="leftContent">
            <img class="loadingGif" src="./assets/loading.gif" />
            <div>开始时间：{{ startTime }}</div>
            <div>此过程不超过5分钟</div>
          </div>
        </div>
        <div class="right" v-if="agent === 'official'">
          <div class="rightContent">
            <img class="erCode" src="./assets/vincicarWxPublic.png" />
            <div>问题咨询、技巧交流</div>
            <div>请关注微信公众号</div>
          </div>
        </div>
        <div class="lastTip">
          若超过5分钟，请长按屏幕左侧HOME键，结束浏览器后重试
        </div>
      </div>
    </div>
    <div id="hiddenIframeBox"></div>

    <div class="beian">
      <a href="https://beian.miit.gov.cn/">{{ beian }}</a>
    </div>
  </div>
</template>

<script>
import { setTimeout } from "timers";

const BsServer1 = "https://a2carf.tssss.cn";
const BsServer2 = "https://freetryb.tssss.cn";

export default {
  name: "app",
  data() {
    return {
      agent: "official",
      useBsServer: BsServer1,
      startTime: "",
      step: "index",
      fullscreen: false,
      beian: "浙ICP备14005433号",
    };
  },
  mounted() {
    this.calcAgent();
    window._hmt = [];

    // (function() {
    //   var hm = document.createElement("script");
    //   var src = "https://hm.baidu.com/hm.js?d2d385bf33026cbd81374cf2868223ee";
    //   if (window.location.href.indexOf("tssss.cn") !== -1) {
    //     src = "https://hm.baidu.com/hm.js?e2d3e016aea00b1d34c77c5596c8d1d0";
    //   }
    //   hm.src = src;
    //   var s = document.getElementsByTagName("script")[0];
    //   s.parentNode.insertBefore(hm, s);
    // })();
    // 思域 实际365
    setTimeout(() => {
      const ele = document.getElementById("app");
      ele.style.width = `${document.documentElement.clientWidth}px`;
      ele.style.height = `${document.documentElement.clientHeight}px`;
    }, 500);

    if (window.location.href.indexOf("tssss.cn") != -1) {
      this.beian = "浙ICP备14005433号-4";
    } else if (
      window.location.href.indexOf("hondavip.cn") != -1 ||
      window.location.href.indexOf("hondavip.net") != -1
    ) {
      this.beian = "浙ICP备14005433号-3";
    }
  },
  methods: {
    calcAgent() {
      const hostname = window.location.hostname;
      let agent = "";
      const prefix = hostname.replace(".tssss.cn", "");
      switch (prefix) {
        case "al": {
          agent = "al";
          break;
        }
        case "v": {
          agent = "yzlpy";
          break;
        }
        case "h": {
          agent = "xiang";
          break;
        }
        case "888": {
          agent = "muliqi";
          break;
        }
        case "st007": {
          agent = "liu2";
          break;
        }
        case "007": {
          agent = "liu";
          break;
        }
        case "111": {
          agent = "guagua";
          break;
        }
        case "ccc": {
          agent = "guagua2";
          break;
        }
        case "000": {
          agent = "guagua3";
          break;
        }
        case "11": {
          agent = "guagua";
          break;
        }
        case "555": {
          agent = "guagua4";
          break;
        }
        case "100": {
          agent = "guagua5";
          break;
        }
        case "999": {
          agent = "guagua6";
          break;
        }
        case "666": {
          agent = "guagua7";
          break;
        }
        // case 'zk': {
        //   agent = 'wxhonda'
        //   break
        // }
        case "evan": {
          agent = "evan";
          break;
        }
        case "8": {
          agent = "public";
          break;
        }
        case "wg": {
          agent = "weigu";
          break;
        }
        case "mm": {
          agent = "mm";
          break;
        }
        case "6": {
          agent = "a1";
          break;
        }
        case "s": {
          agent = "cs4s";
          break;
        }
        case "ycb": {
          agent = "ycb";
          break;
        }
        case "c64": {
          agent = "c64";
          break;
        }
        case "18": {
          agent = "liu18";
          break;
        }
        case "dj": {
          agent = "dijie";
          break;
        }
        default: {
          agent = "official";
          break;
        }
      }
      try {
        if (window.location.hostname.indexOf("zk.hondavip.cn") !== -1) {
          // agent = 'wxhonda'
        } else if (window.location.hostname.indexOf("888.xwlj.net") !== -1) {
          agent = "muliqi";
        } else if (window.location.hostname.indexOf("dj.hondavip.cn") !== -1) {
          agent = "dj";
        } else if (
          window.location.hostname.indexOf("kudu.hondavip.net") !== -1
        ) {
          agent = "kudu";
        }
      } catch (e) {}
      this.agent = agent;
      this.agentCustom();
    },
    agentCustom() {
      if (this.agent === "dj" || this.agent === "kudu") {
        this.fullscreen = true;
      }
    },
    calcBsServer() {
      try {
        const lastServer = window.localStorage.getItem("lastServerUrl");
        if (lastServer !== null) {
          if (lastServer === BsServer1) {
            this.useBsServer = BsServer2;
          } else {
            this.useBsServer = BsServer1;
          }
        }
        window.localStorage.setItem("lastServerUrl", this.useBsServer);
      } catch (e) {
        // do nothing
      }
    },
    onStart() {
      this.step = "wait";
      // this.calcBsServer();

      // stable版，使用特定服务器特定端口
      if (window.location.href.indexOf("233.tssss.cn") !== -1) {
        this.useBsServer = "https://acrackold.vincicar.com";
      }

      const url = `${this.useBsServer}/go.html?carId=civic&uid=0&token=0&agent=${this.agent}`;
      const iframeTpl = '<iframe class="crack-iframe" src="${url}" />'.replace(
        "${url}",
        url,
      );

      document.getElementById("hiddenIframeBox").innerHTML = iframeTpl;

      window._hmt.push(["_trackEvent", "BsServer", this.useBsServer]);

      const curDate = new Date();
      this.startTime = `${curDate.getHours()}:${
        curDate.getMinutes() < 10 ? "0" : ""
      }${curDate.getMinutes()}`;

      window._hmt.push(["_trackPageview", "/startcrack"]);
      setTimeout(() => {
        window._hmt.push(["_trackPageview", "/time_over_1"]);
      }, 1 * 60 * 1000);
      setTimeout(() => {
        window._hmt.push(["_trackPageview", "/time_over_2"]);
      }, 2 * 60 * 1000);
      setTimeout(() => {
        window._hmt.push(["_trackPageview", "/time_over_3"]);
      }, 3 * 60 * 1000);
      setTimeout(() => {
        window._hmt.push(["_trackPageview", "/time_over_4"]);
      }, 4 * 60 * 1000);
      setTimeout(() => {
        alert(
          "优化超时，请长按屏幕左侧HOME键结束浏览器后，再重试，多次失败请尝试更换WI-FI热点",
        );
        window._hmt.push(["_trackPageview", "/time_over_4_5"]);
      }, 4.5 * 60 * 1000);
    },
  },
};
</script>

<style lang="less">
html,
body {
  padding: 0;
  margin: 0;
  background-color: #000;
  font-size: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
#hiddenIframeBox {
  left: -2000px;
  top: -2000px;
  visibility: hidden;
  position: absolute;
}
#app {
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  min-height: 300px;
  min-width: 600px;
  position: absolute;
  background-image: url("./assets/indexbg.jpg");
  background-size: cover;
  background-position: center center;
  &.dj {
    background-size: 100% 100%;
    background-image: url("./assets/agent/dj.jpeg");
  }
  &.kudu {
    background-size: 100% 100%;
    background-image: url("./assets/agent/kudu.jpeg");
  }
}

.title {
  letter-spacing: 4px;
  color: #fff;
  padding: 0;
  margin: 0;
  font-size: 36px;
  white-space: nowrap;
}
.subTitle {
  color: #00bfff;
  padding: 0;
  margin: 0;
  font-size: 24px;
  white-space: nowrap;
  margin: 20px 0;
}
.btn {
  font-size: 22px;
  border-radius: 5px;
  background-color: #00bfff;
  color: #fff;
  display: inline-block;
  padding: 10px 20px;
}
.waitBox {
  background-color: #000;
  width: 100%;
  height: 100%;
}
.waitContentBox {
  font-size: 16px;
  width: 60%;
  height: 65%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  text-align: center;

  .left,
  .right {
    position: relative;
    color: #00bfff;
    height: 100%;
    display: inline-block;
    width: 50%;
    text-align: center;
  }
  .leftContent {
    display: inline-block;
    left: 0;
    top: 50%;
    width: 100%;
    transform: translateY(-50%);
    padding: 5px;
    position: absolute;
  }
  .rightContent {
    display: inline-block;
    left: 0;
    top: 50%;
    width: 100%;
    transform: translateY(-50%);
    padding: 5px;
    position: absolute;
  }
  .loadingGif {
    width: 45px;
    margin: 10px 0;
  }
  .erCode {
    width: 100px;
  }
}
.lastTip {
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 10px;
  text-align: center;
  color: #999;
}

.darkBg {
  left: 0;
  top: 0;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.25);
  width: 100%;
  height: 100%;
}

.contentBox {
  color: #fff;
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  text-align: center;
}
.fullscreen {
  .contentBox {
    top: auto;
    left: 50%;
    bottom: 0;
  }
  .indexStepBox {
    .title,
    .subTitle {
      display: none;
    }
    .btn {
      background-color: #ff4400;
      padding: 15px 50px;
      margin: 10px;
    }
  }
  .darkBg {
    display: none;
  }
}
.beian {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  a {
    font-size: 12px;
    color: #ccc;
    text-decoration: none;
  }
}
</style>
